import api from '../../api/api';
const options = { timeout: 15000, suppressGlobalError: true };
export const supportApi = {
  promotion: async (signal) =>
    (await api.getPublic('/sponsorships/promotion', { ...options, signal })).data.data,
  catalog: async (locale, signal) =>
    (await api.getPublic('/sponsorships/catalog', { ...options, signal, params: { locale } })).data
      .data,
  roster: async (signal) =>
    (await api.getPublic('/sponsorships/roster', { ...options, signal })).data.data,
  mine: async (signal) => (await api.getAuth('/sponsorships/me', { ...options, signal })).data.data,
};
